import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Print, DirectionsCar } from "@mui/icons-material";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";

const LeasingItemFormStepOne = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { values, form } = props;

  const [leasingItems, setLeasingItems] = useState([]);

  // 🔑 Strażnik: jeśli leasingItem = "" to zamieniamy na null
  useEffect(() => {
    if (values.leasingItem === "") {
      form.change("leasingItem", null);
    }
  }, [values.leasingItem, form]);

  // Funkcja pobierająca samochody i urządzenia
  const getCarOrDeviceData = async (searchTerm) => {
    if (!searchTerm?.length) {
      setLeasingItems([]);
      return [];
    }

    try {
      const [carPayload, devicePayload] = await Promise.all([
        GlobalAuthFetch({ path: `/car/findByVIN/${searchTerm}` }),
        GlobalAuthFetch({
          path: `/device/findBySN?serialNumber=${encodeURIComponent(
            searchTerm.trim(),
          )}`,
        }),
      ]);

      const cars =
        carPayload?.payload?.data?.map((car) => ({
          uuid: car.uuid,
          value: car.name || car.vin || "Brak nazwy",
          label: car.name || car.vin,
          type: "car",
          ...car,
        })) || [];

      const devices =
        devicePayload?.payload?.data?.map((device) => ({
          uuid: device.uuid,
          value: device.name || device.serialNumber || "Brak nazwy",
          label: device.name || device.serialNumber,
          type: "device",
          ...device,
        })) || [];

      const all = [...cars, ...devices];
      setLeasingItems(all);
      return all;
    } catch (error) {
      console.error("Błąd w getCarOrDeviceData:", error);
      setLeasingItems([]);
      return [];
    }
  };

  useEffect(() => {
    if (values.leasingItem) {
      if (values.leasingItem.type === "car") {
        form.change("name", "");
        form.change("type", values.leasingItem.model.entryName || "");
      } else if (values.leasingItem.type === "device") {
        form.change("name", values.leasingItem.printerModel?.modelName || "");
        form.change(
          "type",
          values.leasingItem.printerModel?.deviceType?.entryName || "",
        );
      }
    } else {
      form.change("type", "");
      form.change("name", "");
    }
  }, [values.leasingItem, form]);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:leasing.basicInformation")} />
      <Row>
        <Col xs={6}>
          <Field
            currentValues={values}
            className="leasingItem"
            component={BMXAsynchronous}
            getOptionLabel={(option) => {
              if (typeof option === "string") return option;
              if (option?.label) return option.label;
              return "";
            }}
            autoFocus={true}
            label={`${t("global:leasing.leasingItem")}`}
            name="leasingItem"
            options={leasingItems}
            getData={getCarOrDeviceData}
            data-cy="leasingItem"
            disablePortal={true}
            renderOption={(props, option) => (
              <li
                {...props}
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                {option.type === "car" ? (
                  <DirectionsCar fontSize="small" />
                ) : (
                  <Print fontSize="small" />
                )}
                {option.label}
              </li>
            )}
          />
        </Col>
        <Row>
          <Col xs={6}>
            <Field
              component={BMXTextField}
              label={`${t("global:leasing.name")}*`}
              name="name"
              data-cy="name"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Field
              component={BMXTextField}
              label={`${t("global:leasing.type")}*`}
              name="type"
              data-cy="type"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Field
              component={BMXTextField}
              label={`${t("global:leasing.description")}*`}
              name="description"
              data-cy="description"
            />
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default LeasingItemFormStepOne;
